// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___3L4lQ","BlockerWrap":"style__BlockerWrap___byWP6","Blocker":"style__Blocker___1ygxD","BlockerText":"style__BlockerText___28m0k","Wide":"style__Wide___ptGLl","BlockerImage":"style__BlockerImage___2ryKj","BlockerTitle":"style__BlockerTitle___3Nf78","BlockerDescrip":"style__BlockerDescrip___2DByp","PayForTarifBtn":"style__PayForTarifBtn___2q2Pk","ButtonLogout":"style__ButtonLogout____n-oB","ButtonLeave":"style__ButtonLeave___2faQh","BlockerManager":"style__BlockerManager___Mzc-H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Blocker/style.scss
// module id = 1349
// module chunks = 0